import React, { useEffect, useRef, useState } from "react";
import { Search as SearchAgent } from "@findify/agent";
import { SearchProvider } from "@findify/react-connect";
import clsx from "clsx";
import SearchInput from "./SearchInput";
import SearchResults from "./SearchResults";
import SearchCollectionResults from "./SearchCollectionResults";
import classes from "./SearchContainer.module.scss";

const config = {
	key: process.env.REACT_APP_FINDIFY_KEY,
	user: {
		uid: "uid",
		sid: "sid",
	},
	immutable: true,
	limit: 6,
	debounce: 100
};

const searchAgent = new SearchAgent(config);

const SearchContainer = () => {
	const [open, setOpen] = useState(false);
	const containerRef = useRef(null);

	useEffect(() => {
		if (open) {
			document.body.style.overflowY = "hidden";
			window.scrollTo({
				top: 0
			})
		} else {
			document.body.style.overflowY = "auto";
		}
	}, [open]);

	useEffect(() => {
		const onClick = (e) => {
			if (containerRef.current && !containerRef.current.contains(e.target) && open) {
				setOpen(false);
			}
		};
		document.addEventListener("click", onClick);
		return () => {
			document.removeEventListener("click", onClick);
		};
	}, [open]);

	return (
		<SearchProvider agent={searchAgent} options={{ limit: 6, debounce: 100 }}>
			<button className={classes.button} onClick={() => setOpen(!open)} title="Search" type="button">
				<i className="fa fa-search" />
			</button>
			{open && (
				<>
					<div ref={containerRef} className={classes.container}>
						<div className="container">
							<div className={clsx('row', classes.inputContainer)}>
								<div className="col-xs-12">
									<SearchInput closeSearch={() => setOpen(false)} />
								</div>
							</div>
							<div className="row">
								<div className="col-xs-12 col-md-9">
									<SearchResults />
								</div>
								<div className="col-xs-12 col-md-3">
									<SearchCollectionResults />
								</div>
							</div>
						</div>
					</div>
					<div className={classes.overlay} />
				</>
			)}
		</SearchProvider>
	);
};

export default SearchContainer;
